<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in storehouseIds.filter((i) => i.key !== -1)"
        :key="item.key"
        class="status"
        :class="{ active: origin === item.key }"
        @click="selectOrigin(item.key)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="search_type"
                    placeholder=""
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in search_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-left: -15px; width: 165px">
                  <el-input
                    v-model="search_value"
                    placeholder="请输入搜索内容"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.where"
                    placeholder="仓区"
                    filterable
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.optionsSpace"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    multiple
                    placeholder="代采组"
                    filterable
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in searchOptions.optionsPg"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    multiple
                    filterable
                    placeholder="代采员"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in searchOptions.optionsPgM"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家名称"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.stock_in_source"
                    multiple
                    placeholder="入库来源"
                    filterable
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in searchOptions.optionsType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.blp_type"
                    multiple
                    placeholder="不良品类型"
                    filterable
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in searchOptions.optionsBlpType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.sj_status"
                    placeholder="上架状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in searchOptions.optionsSjStatus"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_allot"
                    placeholder="是否配货"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.optionsIsAllot"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.refunder_id"
                    placeholder="售后退供员"
                    style="width: 150px"
                    filterable
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in searchOptions.dgm_refunder"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.goods_label"
                    placeholder="入仓标签"
                    style="width: 150px"
                    multiple
                  >
                    <el-option
                      v-for="item in searchOptions.optionsGoodsLable"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.sj_type" placeholder="库存状态来源">
                    <el-option label="全部" value="-1"></el-option>
                    <el-option
                      v-for="item in searchOptions.optionsSjType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.space_area"
                    placeholder="货区"
                    multiple
                  >
                    <el-option
                      v-for="item in searchOptions.optionsSpaceArea"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.space_shelf"
                    placeholder="架"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.space_floor"
                    placeholder="层"
                  ></el-input>
                </el-form-item>
                <el-form-item label="入库时间：">
                  <el-date-picker
                    v-model="form.in_time"
                    type="datetimerange"
                    range-separator="至"
                    :default-time="['06:00:00', '06:00:00']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="更新时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    :default-time="['06:00:00', '06:00:00']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" @click="exportExcel">
                    导出</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            padding: 5px 10px;
            background-color: #eee;
            display: flex;
            flex-direction: row;
          "
        >
          <div>
            【数据列表】
            <el-button
              type="text"
              alt="点击获取"
              style="margin-left: 10px"
              @click="getDataTotal"
              >数据汇总:
            </el-button>
            <span v-if="dataTotal.show" style="font-size: 14px">
              库存总件数{{ dataTotal.total_num }}件；库存总金额：￥{{
                dataTotal.total_price
              }}</span
            >
            <span v-else style="font-size: 14px">⬅点击获取</span>
          </div>
          <div
            style="
              display: flex;
              flex: 1;
              flex-direction: row;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <el-tooltip
              content="导入模板的表头为“打标ID”，“次品所属包裹号”，文件导入格式请使用CSV.格式"
              placement="top"
            >
              <el-upload
                ref="uploadRef"
                class="upload-demo"
                :action="action"
                :data="{ origin_id: origin }"
                :on-success="onUploadFilePackageSuccess"
                :on-error="() => $message.error('导入发生错误, 请及时联系技术')"
                :show-file-list="false"
                :auto-upload="true"
                :limit="1"
                with-credentials
              >
                <el-button type="primary" size="small">
                  导入次品所属包裹
                </el-button>
              </el-upload>
            </el-tooltip>
          </div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column align="center" label="图片">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.middle_img.length > 0"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="scope.row.middle_img[0]"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.middle_img)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="goods_name"
              label="商品名称"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="wcg_plan_info_goods_label"
              label="入仓标签"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_kh"
              label="款号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_lib_activity_goods"
              label="是否赠品"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_cross_order_dbid"
              label="是否跨仓调拨"
              align="center"
            >
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="dbid"
              label="打标id"
              width="150"
            >
              <template slot-scope="scope">
                <div type="text" @click="openQrCode('dbid=' + scope.row.dbid)">
                  {{ scope.row.dbid }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="货号/颜色/尺码">
              <template slot-scope="scope">
                {{ scope.row.goods_no }}/ {{ scope.row.co_val }}/
                {{ scope.row.si_val }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku编号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="cat_name"
              label="商品分类"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="market_name"
              label="市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="brand_name"
              label="品牌"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgm_name"
              label="代采员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refunder"
              label="售后退供员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="入库人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="in_time"
              label="入库时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="更新时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_in_record_stock_source"
              label="入库来源"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_detail_sj_type"
              label="库存状态来源"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="blp_type"
              label="不良品类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_detail_where"
              label="仓区"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="space"
              label="所在仓位"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="dp_package_no"
              label="次品所属包裹号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_detail_sj_status"
              label="上架状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_detail_is_allot"
              label="是否配货"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stock_detail_is_cut"
              label="退换区是否分播"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="consignment_period"
              label="寄售期（天）"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { isEmpty } from "lodash-es";
import PreviewImage from "../../components/PreviewImage.vue";
import Global_ from "../../components/Global.vue";
import apiBaseURL from "@/utils/baseUrl.js";
import { openDownloadWindow } from "@/utils/export.js";

export default {
  components: {
    PreviewImage,
    // eslint-disable-next-line vue/no-unused-components
    QrcodeVue,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      form: {
        pagesize: 50,
        create_time: this.defaultDate(),
        is_data_total: 0,
        refunder_id: "",
        space_area: [],
        space_shelf: "",
        space_floot: "",
      },
      search_type: "dbid",
      search_options: [
        { key: "dbid", name: "打标id" },
        { key: "sku", name: "sku编号" },
        { key: "goods_no", name: "货号" },
        { key: "goods_kh", name: "款号" },
      ],
      search_value: "",
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      origin: 1,
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/StockDetail/StockDetailList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      searchOptions: {},
      dataTotal: {
        show: false,
        total_num: 0, // 列表上面的数据汇总
        total_price: 0.0,
      },
      action: `${apiBaseURL}/erp/InventoryDp/importDpWithPackage`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    openQrCode(text) {
      if (Global_.environment === 0) {
        const h = this.$createElement;
        this.$msgbox({
          title: text,
          center: true,
          showConfirmButton: false,
          message: h(
            "QrcodeVue",
            {
              props: {
                value: text,
                size: 152,
                level: "H",
              },
            },
            null
          ),
        });
      }
    },
    // 获取数据汇总
    getDataTotal() {
      this.$set(this.form, "is_data_total", 1);
      this.fetchData(false);
    },
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-2, 6);
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    selectOrigin(originId) {
      this.origin = originId;
      this.form.origin = originId;
      this.fetchData(true);
    },

    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchCondition() {
      this.$http
        .post("/erp/StockDetail/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
            this.origin = res.data.data.origin;
          }
        });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value !== "") {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }

      this.$http
        .post(this.url, this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (this.form.is_data_total == 1) {
            this.$set(this.dataTotal, "total_num", res.data.data.count);
            this.$set(this.dataTotal, "total_price", res.data.data.list);
            this.$set(this.dataTotal, "show", true);
          } else {
            this.resData = res.data.data;
          }
        })
        .finally(() => {
          if (this.form.is_data_total) {
            this.$set(this.form, "is_data_total", 0);
          }
        });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      const claimsDetailId = [];
      Object.keys(val).forEach((key) => {
        multipleSelection[key] = val[key].work_id;
        if (val[key].claims_detail_id) {
          claimsDetailId[key] = val[key].claims_detail_id;
        }
      });
      this.multipleSelection = multipleSelection;
      this.claims_detail_id = claimsDetailId;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
      this.form.pagesize = 50;
    },
    // 导入配置成功
    onUploadFilePackageSuccess(rep) {
      if (rep.code !== 200) {
        this.$message.error(rep.msg);
      } else if (!isEmpty(rep.data)) {
        openDownloadWindow(rep.data);
      } else {
        this.$message.success("导入成功");
      }
      this.$refs.uploadRef.clearFiles();
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/stockdetail/StockDetalList.vue